import {SxType} from "@baseTypes/sx/sxTypes";
import {HEIGHT_TOP_SIDEBAR_SINGLE_VOYAGE} from "@containers/singleVoyage/views/constants/size";
import {SV_DARK, SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        width: '100%',
        height: HEIGHT_TOP_SIDEBAR_SINGLE_VOYAGE,
        alignItems: 'center',
        padding: '8px 16px',
        gap: '12px',
        flexShrink: '0',
        borderBottom: '1px solid',
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            borderColor: SV_LIGHT.line,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            borderColor: SV_DARK.line,
        }
    }
}
